import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";
import Frontpage from "./pages/Frontpage";
import New from "./pages/New";
import Top from "./pages/Top";
import Search from "./pages/Search";
import PostPage from "./pages/PostPage";
import ItemPage from "./pages/ItemPage";
import TerritoryPage from "./pages/TerritoryPage";
import Rewards from "./pages/Rewards";
import PaymentsSettings from "./pages/PaymentsSettings";
import { AppLayout } from "./components/stashstr/AppLayout";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* App shell routes */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<Frontpage />} />
          <Route path="/new" element={<New />} />
          <Route path="/top" element={<Top />} />
          <Route path="/top/:timeframe" element={<Top />} />
          <Route path="/top/:timeframe/:metric" element={<Top />} />
          <Route path="/search" element={<Search />} />
          <Route path="/post" element={<PostPage />} />
          <Route path="/t/:tag" element={<TerritoryPage />} />
          <Route path="/t/:tag/:timeframe" element={<TerritoryPage />} />
          <Route path="/t/:tag/:timeframe/:metric" element={<TerritoryPage />} />
          <Route path="/items/:nip19" element={<ItemPage />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/settings/payments" element={<PaymentsSettings />} />
        </Route>

        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
